import ApiService from "../ApiService";

const DefaultService = {
    // loadApp: (successCallback, failureCallback) => {
    //     ApiService.post(
    //         "/web/app/load",
    //         {},
    //         response => {
    //             let snakeCaseObject = Helper.convertCamelCaseKeysToUpperSnakeCase(response);
    //             //update app config
    //             DebugLogger.groupMessage("Get New App Config From Server", snakeCaseObject);
    //             AppConfig.updateAppConfig(snakeCaseObject);
    //             DebugLogger.groupMessage("Update App Config", AppConfig);

    //             // once app is loaded, then we want to update api service url since
    //             // it could be changed by the server based on the location of client
    //             ApiService.setBaseURL(AppConfig.APP_SERVICE_BASE);

    //             if (successCallback) successCallback(response);
    //         },
    //         failureCallback
    //     );
    // },

    registerAppSubscription: (supportedThirdPusherType, id, appId, appType, successCallback, failureCallback) => {
        ApiService.get("/default/registerappsubscription", { supportedThirdPusherType, id, appId, appType }, successCallback, failureCallback);
    },

    unregisterAppSubscription: (supportedThirdPusherType, id, successCallback, failureCallback) => {
        supportedThirdPusherType = supportedThirdPusherType === null ? 0 : supportedThirdPusherType;
        id = id === null ? "" : id;
        ApiService.get("/default/unregisterappsubscription", { supportedThirdPusherType, id, }, successCallback, failureCallback);
    },

    addErrorData: (inVO, successCallback, failureCallback) => {
        ApiService.post("/web/admin/error/details/add", inVO, successCallback, failureCallback);
    },
};

export default DefaultService;
